<template>
  <div>
    <v-dialog v-model="dialogConfirmSave" @keydown.esc="onCancel" persistent max-width="700px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on">mdi-delete-outline</v-icon>
      </template>
      <v-card>
        <v-card-title>
          Da li želite da obrišete korisnika?
        </v-card-title>

        <v-card-text>
          <b class="red--text">VAŽNO</b>
          <br />
          <b>
            Brisanje korisnika uključuje brisanje podataka o samom korisniku, njegovih logova o prijavljivanju na servis, uklanjanje iz baze korisnika na Firebase.
            Takođe, ukoliko je korisnik imao ulogu "Vlasnik", ova uloga se prebacuje na drugog korisnika vezanog za istu kompaniju.
            Ukoliko nema drugog korisnika vezanog za kompaniju, kompanija se deaktivira.
          </b>
        </v-card-text>

         <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="plain ma-2" text @click="dialogConfirmSave = false">
            Odustani
          </v-btn>
          <v-btn class="error ma-2" text @click="onConfirmDeleteUser" :loading="puttingToApi">
            Obriši
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as apiUsers from '../api/users';

export default {
  name: 'DeleteUserDialog',
  data: function () {
    return {
      dialogConfirmSave: false,
      puttingToApi: false,
      deleting: false,
    }
  },
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  methods: {
    onCancel() {
      this.dialogConfirmSave = false;
    },
    onConfirmDeleteUser() {
      this.puttingToApi = true;

      apiUsers.deleteUser(this.userId, this.$store.getters.token)
        .then(response => response.json())
        .then(() => {
          // loading na dugmetu
          this.puttingToApi = false;

          // zatvaranje modalnih prozora
          this.dialogConfirmSave = false;
        })
        .catch(() => {
          this.puttingToApi = false;
        });
    },
  }
}
</script>
